import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Viewer from "./components/Viewer";
import NotFoundPage from "./components/404_error/NotFoundPage";
import { UserProvider } from "./context/Usercontext";

function App() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    // Block devtools shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
        alert("Inspect is disabled!");
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    // Detect if DevTools is open
    let devToolsOpened = false;
    const detectDevTools = setInterval(() => {
      const threshold = 160;
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        if (!devToolsOpened) {
          devToolsOpened = true;
          alert("Inspect tools are not allowed!");
        }
      } else {
        devToolsOpened = false;
      }
    }, 1000);

    // Cleanup
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      clearInterval(detectDevTools);
    };
  }, []);

  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/:id" element={<Viewer />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
